import { Box, Chip } from "@mui/material";

import React from "react";

export default function ChatSuggestions({ suggestions, onSuggestionSelected, disabled }) {

    return <Box sx={{
        display: 'flex',
        p: 1,
        gap: 1,
        flexWrap: 'wrap',
        justifyContent: 'center'
    }}>
        {suggestions.map((s, i) => {
            return <Chip
                key={i}
                variant="outlined"
                color={s.important ? "warning" : "primary"}
                disabled={disabled}
                onClick={() => onSuggestionSelected(s)}
                label={s.shortDisplayText || s.displayText}
            >
            </Chip>
        })}
    </Box>
}
